import React from "react";
import { GrantsLabelItem } from "../../../services/grantsApi";
import { getColorConfig } from "./labelColors";

interface LabelFilterProps {
  labels: GrantsLabelItem[];
  filterMode: "all" | "labeled" | string; // 'all', 'labeled', or label ID
  onFilterChange: (mode: "all" | "labeled" | string) => void;
  totalCount?: number;
  filteredCount?: number;
}

const LabelFilter: React.FC<LabelFilterProps> = ({
  labels,
  filterMode,
  onFilterChange,
  totalCount,
  filteredCount,
}) => {
  if (labels.length === 0) return null;

  return (
    <div className="flex items-center gap-2 flex-wrap">
      <button
        onClick={() => onFilterChange("all")}
        className={`text-xs px-2 py-1 rounded border ${
          filterMode === "all"
            ? "bg-primary-50 border-primary-300 text-primary-700 font-medium"
            : "border-neutral-300 text-neutral-600 hover:bg-neutral-50"
        }`}
      >
        Wszystkie
      </button>
      <button
        onClick={() => onFilterChange("labeled")}
        className={`text-xs px-2 py-1 rounded border ${
          filterMode === "labeled"
            ? "bg-primary-50 border-primary-300 text-primary-700 font-medium"
            : "border-neutral-300 text-neutral-600 hover:bg-neutral-50"
        }`}
      >
        Tylko oznaczone
      </button>
      {labels.map((label) => {
        const cfg = getColorConfig(label.color);
        const isActive = filterMode === label.id;
        return (
          <button
            key={label.id}
            onClick={() => onFilterChange(isActive ? "all" : label.id)}
            className={`text-xs px-2 py-1 rounded border flex items-center gap-1 ${
              isActive
                ? "bg-primary-50 border-primary-300 text-primary-700 font-medium"
                : "border-neutral-300 text-neutral-600 hover:bg-neutral-50"
            }`}
          >
            <span className={`w-2 h-2 rounded-full ${cfg.dot}`} />
            {label.name}
          </button>
        );
      })}
      {filterMode !== "all" &&
        totalCount !== undefined &&
        filteredCount !== undefined && (
          <span className="text-xs text-neutral-500 ml-2">
            Pokazuje {filteredCount} z {totalCount} artykułów
          </span>
        )}
    </div>
  );
};

export default LabelFilter;
